import { useMutation, useQuery } from "@tanstack/react-query";
import { retryNon4xx } from "shared/api/query-retry";
import { activityAdminApi } from "../../api/activityAdminApi";
export var useCollectionActivity = function (collectionId, filters) {
    return useQuery({
        queryKey: ["admin", "activity", collectionId, filters !== null && filters !== void 0 ? filters : {}],
        queryFn: function () { return activityAdminApi.list(collectionId, filters); },
        enabled: !!collectionId,
        staleTime: 15000,
        retry: retryNon4xx,
    });
};
export var useExportActivity = function (collectionId) {
    return useMutation({
        mutationFn: function (filters) {
            return activityAdminApi.exportCsv(collectionId, filters);
        },
    });
};
